module.exports = __webpack_public_path__ + "media/images/login-background-1-42ebba87d451cb904ae4a5f4bd94919a.jpeg";